//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import get from 'lodash/get';
import Loading from '../../ui/Loading.vue';
import PDPFilter from './PDPFilter.vue';
import PDPComment from '../comment/PDPComment.vue';
import PDPEmptyStateCard from '../PDPEmptyStateCard.vue';

export default {
  name: 'PDPCommentTabs',
  components: {
    Loading,
    PDPComment,
    PDPFilter,
    PDPEmptyStateCard,
  },
  inject: {
    forDiscussionPage: {
      default: false,
    },
  },
  props: {
    allowFlagging: {
      type: Boolean,
    },
    commentLink: {
      type: Object,
      default: () => ({}),
    },
    comments: {
      type: Array,
      default: () => ([]),
    },
    dealName: {
      type: String,
      required: true,
    },
    dealPartnerUserIds: {
      type: Array,
      required: true,
    },
    isLoadingComments: {
      type: Boolean,
    },
    hasPurchased: {
      type: Boolean,
    },
    isSearching: {
      type: Boolean,
    },
    filterComments: {
      type: Boolean,
    },
    reviewCount: {
      type: Number,
      default: 0,
    },
    highlightComment: {
      type: String,
      default: '',
    },
    forceShowAll: {
      type: Boolean,
    },
    showAllChildren: {
      type: Boolean,
      required: true,
    },
    unapprovedComments: {
      type: Object,
      default: () => ({}),
    },
    unresolvedComments: {
      type: Object,
      default: () => ({}),
    },
    user: {
      type: Object,
      default: () => ({}),
    },
    hasItems: {
      type: Boolean,
      required: true,
    },
    commentCount: {
      type: Number,
      required: true,
    },
    commentTypeTitle: {
      type: String,
      required: true,
    },
    commentTypeTitleLc: {
      type: String,
      required: true,
    },
    forQuestions: {
      type: Boolean,
      required: true,
    },
    forReviews: {
      type: Boolean,
      required: true,
    },
    isModeratorView: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    showFilter() {
      return (this.filterComments && this.user.isModerator) || this.user.isStaff;
    },
    emptyStateTitle() {
      if (this.forQuestions) {
        return this.isSearching
          ? 'A question so good, it hasn\'t been asked... yet'
          : 'No one has asked a question... yet';
      }

      return this.isSearching
        ? 'Hmm, no one has mentioned that... yet'
        : 'No one has reviewed this product... yet';
    },
    emptyStateDescription() {
      if (this.forQuestions) {
        return this.isSearching
          ? `Ask the ${this.dealName} team now to get answers.`
          : `Be the first to ask a question. Get a reply from the ${this.dealName} team.`;
      }

      return this.isSearching
        ? 'Write a review now. (Purchase required.)'
        : 'Be the first to write a review. (Purchase required.)';
    },
    unApprovedCount() {
      const unApprovedField = this.forQuestions
        ? 'unapproved_question_count'
        : 'unapproved_review_count';

      return this.statusCount('unapprovedComments', unApprovedField);
    },
    unResolvedCount() {
      const unResolvedField = this.forQuestions
        ? 'unresolved_question_count'
        : 'unresolved_review_count';

      return this.statusCount('unresolvedComments', unResolvedField);
    },
    allowCreateItem() {
      if (!this.user?.isAuthenticated) {
        return false;
      }

      return this.forQuestions || (this.forReviews && this.hasPurchased);
    },
  },
  methods: {
    onClickFlag(value) {
      this.$emit('click-flag', value);
    },
    onClickRefresh() {
      this.$emit('on-click-refresh', { resetHash: false });
    },
    onClickClear() {
      this.$emit('on-click-refresh', { resetHash: true });
    },
    onChangeFilter(data) {
      this.$emit('on-change-filter', data);
    },
    replyComment(data) {
      this.$emit('reply-comment', data);
    },
    toggleComment(data) {
      this.$emit('toggle-comment', data);
    },
    toggleShowAll() {
      this.$emit('toggle-show-all-children');
    },
    statusCount(type, key) {
      return get(this, [type, key], 0);
    },
    updateAction(value) {
      this.$emit('update-action', value);
    },
  },
};
